export default {
  contained: {
    boxShadow: 'none',
    backgroundColor: '#FFFFFF'
  }
};
